<div class="d-flex flex-column h-100">
    <!-- PM Edit Bar -->
    <publish-bar 
        *ngIf="!iscxonedashboard"
        [hidden]="!publishPending || isSharedURL" 
        class="w-100"
        [type]="'publish'"
        (save)="publishChanges();"
        (discard)="discardChanges();"></publish-bar>

    <!-- PM Template Save to Dashboards -->
    <publish-bar
        *ngIf="!iscxonedashboard"
        [hidden]="!temporaryDashboardPending || isSharedURL"
        class="w-100"
        [type]="'template'"
        (save)="saveTemporaryDashboard();"
        (discard)="discardTemporaryDashboard();">
    </publish-bar>


    <div class="grid-background flex-fill"
         [class.has-taskbar]="service.taskbarModules.length > 0 && !states.dashboardModules.loading && !dashboardManager.isShared"
         [class.publish-pending]="publishPending || temporaryDashboardPending"
         [class.fullscreen]="isFullscreen"
         [class.grid-background-padding]="iscxonedashboard"
         [class.viaBrowser]="service.isDashboardWindow"
         [style.height]="iscxonedashboard ?? 'auto'"
         (drop)="onDrop($event)"
         (dragover)="dragOver($event)"
         (dragenter)="dragEnter($event)"
         (dragleave)="dragLeave($event)"
         cvNavigationSidebarClass
         #gridBackground>
        <cv-loader [overlay]="true" size="large" *ngIf="showLoader" [loaderType]="iscxonedashboard ? 'cxone' : 'clearview'" [cxoneIsSpinner]="false"></cv-loader>

        <div id="fullscreenToggle" [hidden]="navigationService.showOverlay || iscxonedashboard" [class.viaBrowser]="service.isDashboardWindow" class="fullscreen-toggle">
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" [hidden]="isFullscreen" (click)="toggleFullscreen()">
                <svg class="icon-16">
                    <use href="../App_Themes/clearview-default/icons/utility/expand.svg#expand"></use>
                </svg>
            </button>
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" [hidden]="!isFullscreen" (click)="toggleFullscreen()">
                <svg class="icon-16">
                    <use href="../App_Themes/clearview-default/icons/utility/shrink.svg#shrink"></use>
                </svg>
            </button>
        </div>

        <div class="grid-no-modules" *ngIf="!showLoader && !modules?.length && !iscxonedashboard">
            <div class="grid-no-modules-message" *ngIf="dashboardManager.writeAccess" cvLocalizedText langSection="Module_Menu" langKey="No_Modules_Message">Click or drag modules from the left to add them to your dashboard.</div>
            <div class="grid-no-modules-message" *ngIf="!dashboardManager.writeAccess" cvLocalizedText langSection="Module_Menu" langKey="No_Widgets_Added">No widgets have been added to this dashboard.</div>
        </div>

        <div class="cxone-grid-no-modules" *ngIf="!showLoader && !modules?.length && iscxonedashboard">
            <div class="cxone-grid-no-modules-message" cvLocalizedText langSection="CXOne_Dashboard" langKey="No_Widgets_Message">Click a widget Or drag here</div>
        </div>

        <gridster id="gridster" [ngClass]="publishPending ? 'grid-canvas-publish' : 'grid-canvas'" [class.grid-canvas-cxone]="iscxonedashboard"
                  [hidden]="showLoader || modules?.length === 0" [options]="gridsterOptions" #gridCanvas>
            <gridster-item [class.focused]="item.moduleKey && focusedModuleKey === item.moduleKey" [class.projection]="service.isDashboardProjection"
                [item]="item" *ngFor="let item of this.modules">
                <div [ngClass]="item.isPlaceholder === true ? 'grid-item-placeholder gridster-item-moving' : 'gridItem'">
                    <cv-module-container *ngIf="!item.isPlaceholder"
                                         [dashboardManager]="dashboardManager"
                                         [module]="item"
                                         [moduleId]="item.ModuleID"
                                         [mkey]="item.moduleKey"
                                         [publishBar]="iscxonedashboard">
                    </cv-module-container>
                </div>
            </gridster-item>
        </gridster>

        <!-- PM counter -->
        <div class="module-count color-inversion shadow position-fixed px-3 py-1 d-flex flex-row justify-content-start"
             *ngIf="!navigationService.showOverlay && !iscxonedashboard"
             [class.has-taskbar]="service.taskbarModules.length > 0">
            <div class="module-count-label d-flex flex-row">
                <span cvLocalizedText langSection="CXOne_Dashboard" langKey="Widgets">Widgets</span>
                <span>:</span>
            </div>
            {{ modules?.length ?? 0 }} / {{ service.MAX_MODULES }}
        </div>
    </div>
</div>

<cv-user-idle [isEnabled]="isIdleEnabled" [isActive]="isActive || dashboardManager.isDashboardWindow" (onIdleChange)="onIdleChange($event)"></cv-user-idle>
